import type { PageRef } from '@wix/editor-platform-sdk-types'
import type { AppApi } from '@wix/wix-data-client-common'
import {
  runTransactionWithRetry,
  UNDO_REDO_LABELS,
} from '@wix/wix-data-client-common'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import { getPageRouteData } from '../../../worker/utils/getPageRouteData'

export const updateDynamicPagePrefix = async ({
  editorSdkProxy,
  appApi,
  pageRef,
  prefix,
}: {
  editorSdkProxy: EditorSDK
  appApi: AppApi
  pageRef: PageRef
  prefix: string
}) => {
  const { routerData, routerRef } = await getPageRouteData({
    editorSdkProxy,
    pageRef,
  })

  const newPrefix = prefix.toLowerCase()

  if (routerData.prefix === newPrefix) {
    return
  }

  if (routerData.pages.length > 1) {
    throw new Error('Not implemented for routers with multiple routes')
  }

  await runTransactionWithRetry(editorSdkProxy, async () => {
    await editorSdkProxy.routers.update({ routerRef, prefix: newPrefix })
  })

  await editorSdkProxy.history.add({
    label: UNDO_REDO_LABELS.UPDATE_ROUTERS,
    params: { pageRefs: [pageRef] },
  })

  await appApi.handleChangedRouters({ pageRefs: [pageRef] })
}
